import { render } from "./FeaturesTemplate.vue?vue&type=template&id=96371c28"
import script from "./FeaturesTemplate.vue?vue&type=script&lang=js"
export * from "./FeaturesTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__